var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isActive
      ? _c("span", { staticClass: "badge-info p-1 px-2" }, [
          _vm._v(_vm._s(_vm.$t("planning.state_labels.activated"))),
        ])
      : _c("span", { staticClass: "badge-secondary p-1 px-2" }, [
          _vm._v(_vm._s(_vm.$t("planning.state_labels.deactivated"))),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }